/**
 * Campaign language targeting — dashboard route (feature #73).
 *
 * URL: /campaigns/language-targeting
 *
 * Renders the <LanguageTargetingForm/> inside the shared dash layout shell.
 * The route exports both the TanStack Router `createRoute` definition
 * (attached to the `__root` tree) and the React component so the router
 * file can lazily reference it without triggering circular imports.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { LanguageTargetingForm } from "../features/language-targeting/LanguageTargetingForm";

export function CampaignsLanguageTargetingRoute() {
	return (
		<main className="mx-auto flex min-h-screen w-full max-w-4xl flex-col gap-8 px-6 py-12">
			<header className="flex flex-col gap-2">
				<p className="text-xs font-medium uppercase tracking-[0.12em] text-zinc-400">
					Campaigns / Targeting
				</p>
				<h1 className="text-brand-gradient text-4xl font-semibold tracking-tight sm:text-5xl">
					Language targeting
				</h1>
				<p className="max-w-2xl text-sm text-zinc-500">
					Control which visitor languages can reach a campaign. Build an allow
					list for strict regional traffic, or a deny list to filter out
					unwanted locales. Rules apply to the preferred language from the
					visitor's Accept-Language header.
				</p>
			</header>

			<LanguageTargetingForm />
		</main>
	);
}

export const campaignsLanguageTargetingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaigns/language-targeting",
	component: CampaignsLanguageTargetingRoute,
});

export default campaignsLanguageTargetingRoute;
